<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/organization/abstract')"></span>
    </div>
    <div class="title">请选择您的房型</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepaid50.png'> -->
    <br>
		<div class="main clearfix">
			<div class="cell" @click="orderUpdate('house_type','1','/organization-step2');">
				<img src="../../assets/img/clean/type/apartment.svg">
				<div>Apartment<br><span>电梯公寓</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','2','/organization-step2');">
				<img src="../../assets/img/clean/type/unit.svg">
				<div>Unit<br><span>无电梯公寓</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','3','/organization-step2');">
				<img src="../../assets/img/clean/type/house.svg">
				<div>House<br><span>独立别墅</span></div>
			</div>

			<div class="cell" @click="orderUpdate('house_type','4','/organization-step2');">
				<img src="../../assets/img/clean/type/townhouse.svg">
				<div>Town House<br><span>联排别墅</span></div>
			</div>

			<div class="cell last" @click="orderUpdate('house_type','5','/organization-step2');">
				<img src="../../assets/img/clean/type/studio.svg">
				<div>Studio<br><span>无客厅套房</span></div>
			</div>

			<div class="cell last" @click="orderUpdate('house_type','6','/organization-step2');">
				<img src="../../assets/img/clean/type/other.svg">
				<div>Other<br><span>其它</span></div>
			</div>
		</div>

    <img :src="pixelURL('clean','huxing')" class="hide">
  </div>


</template>

<script>
export default {
  name: 'clean-step1',
  data () {
    return {
			showModal: false,
      order:{
        service:'organization',
        data:{
          house_type: "",
          livingroom: '',
          bedroom: '',
          bathroom: '',
          toiletroom: '',
          address_name: "",
          address_phone: "",
          address_state: "NSW",
          address_suburb: "",
          address_street: "",
          address_unit: "",
          address_postcode: "",
					parking:"",
          msg:"",
          msgAttach:"",
          type_id:"1550735986",
          coupon_title:"",
          coupon_id:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:''
        }
      }
    }
  },
  methods: {

  },
  components: {
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedOrganization){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedOrganization;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "organization"){
          localStorage.order = localStorage.savedOrganization;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "organization"){
        this.order = localParsed;
        this.order.type_id = "1550735960";
      }
    }
    if(this.$route.query.msg){
        let result = '';
        switch (this.$route.query.msg) {
          case "1":
            result = '系统备注：用户的房屋是住宅'
            break;
          case "2":
            result = '系统备注：用户的房屋是办公室'
            break;
          case "3":
            result = '系统备注：用户的房屋是商铺'
            break;
          default:
            console.log("1");
        }
        this.order.data.msgAttach = result;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
  padding:0 30px 30px 30px;
}
.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #DDD;
	box-sizing: border-box;
	height: 130px;
	text-align: center;
	cursor: pointer;
}
.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #DDD;
}
.cell.last{
	border-bottom:0;
  padding-top:10px;
}
.cell img{
	width:60px;
}

.cell div{
	margin-top:4px;
	color:#595D68;
  line-height:1.3;
  span{
    font-size:0.84em;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/organization/step1.vue